import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import ProductCard from '../components/ProductCard';
import { allProducts } from '../data/mockData';
import { Search, SlidersHorizontal } from 'lucide-react';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

const Products = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [products, setProducts] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [animalsData, setAnimalsData] = useState([]);
  const [foodData, setFoodData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
    fetchCategoriesData();
    fetchAnimalData();
    fetchFoodData();
  }, []);

  const goToProductPage = (type, id) => {
    navigate(`/products?${type}=${id}`);
  };

  const fetchAnimalData = async () => {
    const querySnapshot = await getDocs(collection(db, "animalCategories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setAnimalsData(list)
  };

  const fetchFoodData = async () => {
    const querySnapshot = await getDocs(collection(db, "foodCategories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setFoodData(list)
  };



  const fetchProducts = async () => {
    const querySnapshot = await getDocs(collection(db, "products"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setProducts(list)
  };

  const fetchCategoriesData = async () => {
    const querySnapshot = await getDocs(collection(db, "categories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setCategoriesData(list)
    console.log(list)
  };



  return (
    <div className="py-5" style={{backgroundColor: '#1d394e24'}}>
      <div className='mx-4'>
        {/* Page Header */}
        <div className="text-center mb-5">
          <div className="mb-3">
            <p className="text-muted">
              Showing {products.length} product{products.length !== 1 ? 's' : ''}
            </p>
          </div>
        </div>

        {/* Products Grid */}
        <Row>
          <Col lg={4} className='mb-3'>
            <div className="p-4 px-5 rounded-1 shadow-sm">
              <Row className="g-3 align-items-end">
                <Col md={12}>
                  <Form.Label className="fw-bold small mb-2">
                     Search Products
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Search for products..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Col>
                <Col md={12}>
                  <Form.Label className="fw-bold small mb-2">
                     Category
                  </Form.Label>
                  <Form.Select
                  // value={selectedCategory}
                  // onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    {categoriesData.map(category => (
                      <option key={category?.id} value={category?.name}>
                        {category?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <Col md={12}>
                  <Form.Label className="fw-bold small mb-2">
                     Animals
                  </Form.Label>
                  <Form.Select
                  // value={selectedCategory}
                  // onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    {animalsData.map(category => (
                      <option key={category?.id} value={category?.name}>
                        {category?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <Col md={12}>
                  <Form.Label className="fw-bold small mb-2">
                     Food Type
                  </Form.Label>
                  <Form.Select
                  // value={selectedCategory}
                  // onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    {foodData.map(category => (
                      <option key={category?.id} value={category?.name}>
                        {category?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

              </Row>
            </div>
          </Col>

          <Col lg={8} className='mt-4'>
            <Row className="g-4">
              {products.length > 0 ? (
                products.map(product => (
                  <Col key={product.id} xs={6} md={4} lg={3}>
                    <ProductCard product={product} />
                  </Col>
                ))
              ) : (
                <Col>
                  <div className="text-center py-5">
                    <h4 className="text-muted">No products found</h4>
                    <p className="text-muted">Try adjusting your filters</p>
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Products;